import { apiSlice } from "../apiSlice/apiSlice";

export const OrderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create an order
    createOrder: builder.mutation({
      query: (orderData) => ({
        url: "/orders/createOrder",
        method: "POST",
        body: orderData,
      }),
      invalidatesTags: ["Order"],
    }),

    // Get all orders
    getOrders: builder.query({
      query: () => ({
        url: "/orders/getOrders",
        method: "GET",
      }),
      providesTags: ["Order"],
    }),

    getOrderById: builder.query({
      query: (id) => ({
        url: `/orders/getOrderById/${id}`,
        method: "GET",
      }),
      providesTags: ["Order"],
    }),

    // Get orders from the last 30 days
    // getOrderLast30Day: builder.query({
    //   query: (search) => ({
    //     url: `/orders/getOrderLast30Day`,
    //     method: "GET",
    //     params: search ? { search } : {},
    //   }),
    //   providesTags: ["Order"],
    // }),

    getCompleteOrder: builder.query({
      query: ({ search, startDate, endDate } = {}) => ({
        url: `/orders/getCompleteOrder`,
        method: "GET",
        params: {
          ...(search && { search }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
        },
      }),
      providesTags: ["Order"],
    }),

    getKitchenReceipt: builder.query({
      query: ({ search, startDate, endDate } = {}) => ({
        url: `/orders/getKitchenReceipt`,
        method: "GET",
        params: {
          ...(search && { search }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
        },
      }),
      providesTags: ["Order"],
    }),


    // Get all pending orders
    getPendingOrders: builder.query({
      query: () => ({
        url: "/orders/getPendingOrders",
        method: "GET",
      }),
      providesTags: ["Order", "completeOrder"],
    }),

    // Update order status
    completingOrder: builder.mutation({
      query: ({ updateOrderData, id }) => ({
        url: `/orders/updateOrderStatus/${id}`,
        method: "PATCH",
        body: updateOrderData,
      }),
      invalidatesTags: ["Order", "completeOrder"],
    }),

    // Change table number
    changeTable: builder.mutation({
      query: ({ newTableNo, orderId }) => ({
        url: `/orders/changeTable/${orderId}`,
        method: "PATCH",
        body: { newTableNo },
      }),
      invalidatesTags: ["Order"],
    }),

    // General order update
    updateOrder: builder.mutation({
      query: (updateOrderData) => ({
        url: "/orders/updateOrder",
        method: "PATCH",
        body: updateOrderData,
      }),
      invalidatesTags: ["Order"],
    }),

    // Update discount on an order
    updateOrderDiscount: builder.mutation({
      query: ({ totalAmountDiscount, discountReason, id, service }) => ({
        url: `/orders/updateOrderDiscount/${id}`,
        method: "PATCH",
        body: { totalAmountDiscount, discountReason, service },
      }),
      invalidatesTags: ["Order"],
    }),

    // Mark order as free
    freeOrder: builder.mutation({
      query: ({ discountReason, id }) => ({
        url: `/orders/freeOrder/${id}`,
        method: "PATCH",
        body: { discountReason },
      }),
      invalidatesTags: ["Order", "completeOrder"],
    }),

    // Delete an order
    deleteOrder: builder.mutation({
      query: (id) => ({
        url: `/orders/deleteOrder/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Order"],
    }),

    // Get orders by datetime range
    getOrdersByDateTimeRange: builder.mutation({
      query: (orderData) => ({
        url: "/orders/getOrdersByDateTimeRange",
        method: "POST",
        body: orderData,
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetOrdersQuery,
  useLazyGetCompleteOrderQuery,
  useGetPendingOrdersQuery,
  useCompletingOrderMutation,
  useChangeTableMutation,
  useUpdateOrderMutation,
  useUpdateOrderDiscountMutation,
  useFreeOrderMutation,
  useDeleteOrderMutation,
  useGetOrdersByDateTimeRangeMutation,
  useGetOrderByIdQuery,
  useLazyGetKitchenReceiptQuery
} = OrderApi;
